<div class="modal-dialog modal-dialog-centered custom-modal" role="document">
  <div class="modal-content">
    <form #printform="ngForm">
      <div class="modal-body">
        <div class="row">

          <!-- Email Section -->
          <div class="col-md-6">
            <label class="pure-material-checkbox">
              <input type="checkbox" [(ngModel)]="emailCheckBox"  name="emailCheckBox" (change)="enableEmail = emailCheckBox">
              <span>Email</span>
            </label>

            <div class="mt-2">
              <input type="text"  class="form-control .email-sms-input" name="email" [(ngModel)]="emailBox"  [pattern]="emailPattern"
                [disabled]="!enableEmail" #email="ngModel">
                @if (email.errors !== null && (email.dirty || email.touched)) {
                  <div class="alert alert-danger"
                    >
                    @if (email.errors.pattern) {
                      <span>
                        Enter valid E-Mail Id
                      </span>
                    }
                  </div>
                }
              </div>
            </div>

            <!-- SMS Section -->
            <div class="col-md-6 doc_opt">
              <label class="pure-material-checkbox checkbox-Margin">
                <input type="checkbox" [(ngModel)]="isSMSChecked" name="isSMSChecked" (change)="enablesms = isSMSChecked">
                <span>SMS</span>
              </label>

              <div class="mt-2">
                <ejs-maskedtextbox [mask]="PhoneNumberMask"  name="sms" [(ngModel)]="phoneNumber" [disabled]="!enablesms"
                  (keyup)="onkeysms($event)" cssClass="form-control p-0 .email-sms-input">
                </ejs-maskedtextbox>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button"
            class="btn btn-primary"
            [disabled]="disabledEmailSmsOkButton()"
            (click)="sendEmailandsms()">
            OK
          </button>
        </div>
      </form>
    </div>
  </div>
